<template>
  <div class="animated fadeIn">
    <basic-heading title="Turnarounds" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list turnaround'">
      <template #gated-content>
        <turnaround-server-table :laboratory_id="laboratory_id" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TurnaroundServerTable from "@/components/lab/turnaround/TurnaroundServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "TurnaroundIndex",
  components: {
    BasicHeading,
    PermissionAlertGate,
    TurnaroundServerTable,
    HeaderButtonGroup,
  },
  data() {
    return {
      laboratory_id: this.$store.getters.getLaboratoryContext.id || null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/turnarounds/add",
            title: "Add turnaround",
            variant: "success",
            permission: this.checkPermission("add turnaround"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
